// Aparición suave de cada sección al entrar en pantalla. No corre en el editor
// del tema ni con «reducir movimiento»; sin este archivo todo se ve igual, quieto.
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const piezas = document.querySelectorAll(
    'main > .shopify-section:not(:first-child) .section-content-wrapper, main > .shopify-section:not(:first-child) .hero__content-wrapper, .pncc-datos__interior, .pncc-encabezado'
  );
  if (!piezas.length) return;

  const observador = new IntersectionObserver(
    (entradas) => {
      for (const entrada of entradas) {
        if (!entrada.isIntersecting) continue;
        entrada.target.classList.add('pncc-visto');
        observador.unobserve(entrada.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px' }
  );

  for (const pieza of piezas) {
    pieza.classList.add('pncc-revela');
    observador.observe(pieza);
  }
  document.documentElement.classList.add('pncc-animar');
})();

// Índice de «Planifica tu viaje»: marca la sección que se está leyendo.
(() => {
  const enlaces = [...document.querySelectorAll('.pncc-indice a[href^="#"]')];
  if (!enlaces.length || !('IntersectionObserver' in window)) return;
  const destinos = new Map();
  for (const enlace of enlaces) {
    const destino = document.getElementById(decodeURIComponent(enlace.hash.slice(1)));
    if (destino) destinos.set(destino, enlace);
  }
  const observador = new IntersectionObserver(
    (entradas) => {
      for (const entrada of entradas) {
        if (!entrada.isIntersecting) continue;
        for (const enlace of enlaces) enlace.removeAttribute('aria-current');
        const actual = destinos.get(entrada.target);
        actual.setAttribute('aria-current', 'true');
        const indice = actual.parentElement;
        indice.scrollTo({ left: actual.offsetLeft - 16, behavior: 'smooth' });
      }
    },
    { rootMargin: '-35% 0px -60% 0px' }
  );
  for (const destino of destinos.keys()) observador.observe(destino);
})();
